"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _jsx2 = _interopRequireDefault(require("@babel/runtime/helpers/jsx"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactInlinesvg = _interopRequireDefault(require("react-inlinesvg"));

var ZapIcon =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2["default"])(ZapIcon, _Component);

  function ZapIcon(props) {
    var _context;

    var _this;

    (0, _classCallCheck2["default"])(this, ZapIcon);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(ZapIcon).call(this, props));
    _this.state = {
      iconToDisplay: null
    };
    _this.loadIcon = (_context = _this).loadIcon.bind(_context);
    return _this;
  }

  (0, _createClass2["default"])(ZapIcon, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      var _this2 = this;

      this.setState({
        icon: this.loadIcon(this.props.icon)
      }, function () {
        if (!_this2.unmounted) {
          _this2.setState({
            iconToDisplay: _this2.state.icon
          });
        }
      });

      if (!this.unmounted && this.props.iconOnHover) {
        this.setState({
          iconOnHover: this.loadIcon(this.props.iconOnHover)
        });
      }

      if (!this.unmounted && this.props.iconIsActive) {
        this.setState({
          iconIsActive: this.loadIcon(this.props.iconIsActive)
        }, function () {
          if (_this2.props.active) {
            _this2.setState({
              iconToDisplay: _this2.state.iconIsActive
            });
          }
        });
      }
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var _this3 = this;

      if (!this.unmounted && nextProps.active && this.state.iconIsActive) {
        this.setState({
          iconToDisplay: this.state.iconIsActive
        });
      } else if (!this.unmounted && nextProps.icon !== this.props.icon) {
        this.setState({
          icon: this.props.icon !== nextProps.icon ? this.loadIcon(nextProps.icon) : this.state.icon
        }, function () {
          _this3.setState({
            iconToDisplay: _this3.state.icon
          });
        });
      }

      if (!this.unmounted && nextProps.iconOnHover !== this.props.iconOnHover) {
        this.setState({
          iconOnHover: this.loadIcon(nextProps.iconOnHover)
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.unmounted = true;
    }
  }, {
    key: "loadIcon",
    value: function loadIcon(toLoad) {
      var icon;

      try {
        icon = require("./resources/".concat(toLoad, ".svg"));
      } catch (e) {
        return null;
      }

      return icon;
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      if (this.state.iconToDisplay) {
        return (0, _jsx2["default"])("span", {
          role: "presentation",
          onClick: function onClick(e) {
            if (_this4.props.iconOnHover) {
              _this4.setState({
                iconToDisplay: _this4.props.active ? _this4.state.iconIsActive : _this4.state.icon,
                hovering: false
              });
            }

            if (_this4.props.onClick) {
              _this4.props.onClick(e);
            }
          },
          className: "zap-icon ".concat(this.props.className, " ").concat(this.state.hovering ? 'is-hovered' : ''),
          onMouseEnter: function onMouseEnter() {
            if (_this4.props.iconOnHover) {
              _this4.setState({
                iconToDisplay: _this4.state.iconOnHover,
                hovering: true
              });
            }
          },
          onMouseLeave: function onMouseLeave() {
            if (_this4.props.iconOnHover) {
              _this4.setState({
                iconToDisplay: _this4.props.active ? _this4.state.iconIsActive : _this4.state.icon,
                hovering: false
              });
            }
          }
        }, void 0, (0, _jsx2["default"])(_reactInlinesvg["default"], {
          src: this.state.iconToDisplay
        }));
      }

      return null;
    }
  }]);
  return ZapIcon;
}(_react.Component);

(0, _defineProperty2["default"])(ZapIcon, "propTypes", {
  /** The name of the icon to display. */
  icon: _propTypes["default"].string.isRequired,

  /** The name of the icon to display when hover. */
  iconOnHover: _propTypes["default"].string,

  /** The name of the icon to display when active. */
  iconIsActive: _propTypes["default"].string,

  /** Extra classes to add to the icon. */
  className: _propTypes["default"].string,

  /** Icon active status. */
  active: _propTypes["default"].bool,

  /** Function to call when clicking the icon. */
  onClick: _propTypes["default"].func
});
(0, _defineProperty2["default"])(ZapIcon, "defaultProps", {
  active: false,
  className: '',
  iconOnHover: '',
  iconIsActive: '',
  onClick: function onClick() {
    return null;
  }
});
var _default = ZapIcon;
var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ZapIcon, "ZapIcon", "/Users/quentin/Projects/zap/zap-icons/src/ZapIcon.jsx");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/quentin/Projects/zap/zap-icons/src/ZapIcon.jsx");
}();

;